import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79219d37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tariff" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "flex items-center justify-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Редактирование тарифа" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      class: "mt-6",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createVNode(_component_the_input, {
        placeholder: "Вес груза (кг)",
        value: _ctx.state.weight,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.weight) = $event)),
        "is-invalid": _ctx.state_form$.weight.$error,
        "validation-errors": _ctx.state_form$.weight.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        class: "mt-4",
        placeholder: "Тип доставки",
        options: _ctx.SHIPMENT_TYPES,
        value: _ctx.state.typeId,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.typeId) = $event)),
        "is-invalid": _ctx.state_form$.typeId.$error,
        "validation-errors": _ctx.state_form$.typeId.$errors,
        searchable: false
      }, null, 8, ["options", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        class: "mt-4",
        placeholder: "Зона доставки",
        value: _ctx.state.zoneId,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.zoneId) = $event)),
        "is-invalid": _ctx.state_form$.zoneId.$error,
        "validation-errors": _ctx.state_form$.zoneId.$errors,
        loading: _ctx.data_state.zones.is_loading,
        options: _ctx.data_state.zones.list,
        failed: _ctx.data_state.zones.is_failed,
        "error-text": "При получении списка зон доставок произошла ошибка",
        "search-by": "description",
        "select-by": "id",
        label: "description",
        "infinite-scroll": "",
        onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadZones(_ctx.data_state.zones.pagination.current_page))),
        onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreZones(_ctx.data_state.zones.pagination.current_page + 1))),
        onSearch: _ctx.searchZone,
        onOptionBySearch: _ctx.unshiftFoundZone
      }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_input, {
        placeholder: "Минимальный сбор",
        disabled: Boolean(_ctx.state.cost) && +_ctx.state.cost !== 0,
        value: _ctx.state.minimumPrice,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.minimumPrice) = $event)),
        "is-invalid": _ctx.state_form$.minimumPrice.$error,
        "validation-errors": _ctx.state_form$.minimumPrice.$errors
      }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Тариф",
        disabled: Boolean(_ctx.state.minimumPrice) && +_ctx.state.minimumPrice !== 0,
        value: _ctx.state.cost,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.cost) = $event)),
        "is-invalid": _ctx.state_form$.cost.$error,
        "validation-errors": _ctx.state_form$.cost.$errors
      }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_button, {
          type: "submit",
          class: "primary small",
          loading: _ctx.progress.is_loading
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Редактировать тариф ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}